import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { PushPipe } from '@ngrx/component';
import { SystemDataService } from '@wdx/kamino/api-service';
import { setAgGridLicenseKey } from '@wdx/shared/components/ag-grid';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { WdxToastComponent } from '@wdx/shared/components/wdx-toast';
import { WdxDestroyClass } from '@wdx/shared/utils';
import { combineLatest } from 'rxjs';
import { combineLatestWith, filter, map, takeUntil, tap } from 'rxjs/operators';

setAgGridLicenseKey();

@Component({
    imports: [RouterOutlet, WdxSpinnerModule, PushPipe, WdxToastComponent],
    selector: 'ops-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent extends WdxDestroyClass implements OnInit {
    private authService = inject(AuthService);
    private systemDataService = inject(SystemDataService);
    private titleService = inject(Title);

    ngOnInit() {
        combineLatest([
            this.systemDataService.tenant$,
            this.systemDataService.whoAmI$,
        ])
            .pipe(
                takeUntil(this.destroyed$),
                filter(([tenant, whoAmI]) => !!tenant && !!whoAmI),
                map(([tenant, whoAmI]) => {
                    const environment = whoAmI!.environment
                        ? `${whoAmI!.environment[0].toUpperCase()}${whoAmI!.environment.slice(1).toLowerCase()}`
                        : '';
                    return `Kamino - ${tenant!.name} - ${environment}`;
                }),
                tap((title) => this.setTitle(title)),
            )
            .subscribe();
    }

    isAppReady$ = this.authService.isAuthenticated$.pipe(
        combineLatestWith(
            this.systemDataService.isLoading$.pipe(filter((res) => !res)),
        ),
    );

    setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
